import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { DropDown } from 'components';
import { useRealTimeDB } from 'hooks';
import {
  generateReactSelectOptionsFromObject,
  generateReactSelectOptions,
  convertJSONToArray,
} from 'utils/reactSelect';

const formatOptions = (data, model) => {
  if (!data) {
    return [];
  }

  if (Array.isArray(data)) {
    return generateReactSelectOptions(data);
  }

  if (typeof data === 'object') {
    const JSONArray = convertJSONToArray(data);
    return generateReactSelectOptionsFromObject(JSONArray, model);
  }

  return [];
};

const LocationInput = ({ path, error, model, name, ...rest }) => {
  const pathRef = path !== '' ? path : undefined;
  const { status, data, error: fetchError } = useRealTimeDB(pathRef);

  const stateOptions = useMemo(() => formatOptions(data, model), [data, model]);
  const fetchErrorMsg = typeof fetchError === 'undefined' ? '' : `Unable to load ${name}`;

  return (
    <DropDown
      {...rest}
      name={name}
      options={stateOptions}
      rounded
      maxMenuHeight={190}
      error={error || fetchErrorMsg}
      isLoading={status === 'loading'}
    />
  );
};

LocationInput.propTypes = {
  handleOnChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  selectedOption: PropTypes.object,
  error: PropTypes.string,
  path: PropTypes.string.isRequired,
  noOptionsMessage: PropTypes.string,
  model: PropTypes.object,
};

LocationInput.defaultProps = {
  error: '',
  selectedOption: {},
  noOptionsMessage: '',
  model: {},
};

export default LocationInput;
